import { createContext } from 'react';

import type { Theme, ThemeSetting } from './types';

export type ThemeContextType = {
  themeSetting?: ThemeSetting;
  theme?: Theme;
  setTheme: (theme: ThemeSetting) => void;
};

export const ThemeContext = createContext<ThemeContextType>({
  themeSetting: 'default',
  theme: 'default',
  setTheme: () => undefined,
});
